import { Field } from "formik";
import { renderServiceField } from "../../../pages/DataModels/services.helpers";
import { EMPTY_STRING } from "../../../constants";

const CustomRadioButton = (props) => {
  const {
    name,
    options,
    handleChange,
    values,
    currentNode,
    customClasses = "flex flex-col text-sm font-medium m-2",
  } = props;

  const renderChildren = (childrenKeys) => {
    return childrenKeys.map((key) => {
      const child = currentNode.config.find((field) => field.key === key);
      return (
        <div key={key}>
          {child &&
            renderServiceField({
              ...props,
              each: child,
            })}
        </div>
      );
    });
  };

  return (
    <div className={customClasses}>
      {options.map((option) => {
        const label = option instanceof Object ? option.label : option;
        const value = option instanceof Object ? option.value : option;
        return (
          <div className="mb-1" key={value}>
            <label>
              <Field
                type="radio"
                name={name}
                value={value}
                onChange={(e) => {
                  const oldOption = options.find(
                    (option) => option.value === values[name]
                  );
                  const updateField = {};

                  if (oldOption?.childrenKeys)
                    updateField.disable = oldOption.childrenKeys;
                  if (option.childrenKeys)
                    updateField.enable = option.childrenKeys;

                  handleChange(
                    e,
                    name,
                    EMPTY_STRING,
                    EMPTY_STRING,
                    updateField
                  );
                }}
                className="mr-2 disabled:opacity-70"
              />
              {label}
            </label>
            {values[name] === value && option.childrenKeys && (
              <div className="mt-2">{renderChildren(option.childrenKeys)}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default CustomRadioButton;
